// View Keys 
export default {
  reportsModalExtraTime_Title: 'Your request may take some extra time',
  reportsModalExtraTime_inputText: "The report you are trying to run may take some extra time to load. We will notify you when it's ready to view in your browser. In the meantime, we can send it to you as a PDF or CSV  if you'd like.",
  reportsModalExtraTime_sendPDF: "Send PDF",
  reportsModalExtraTime_sendCSV: "Send CSV",
  reportsModalExtraTime_Illwait: "I'll Wait",
  reportsModalExtraTime_email: "Email",
};